import { hasFeatureFlag, hasRoleOneOf } from '@/services';

export { default as HomeAICard } from './biz-components/home-ai-card';
export { default as AILogoEntry } from './biz-components/LogoEntry';

export { default as GrowupEntry } from './biz-components/growup/entry';
export { default as GrowupNotice } from './biz-components/growup/notice';

export { default as useAIAssistant } from './hooks/use-ai-assistant';

export { getAIPageModule } from './modules/analysis/constants/routes';

export type { GrowupReportType } from './biz-components/growup/constants';

export const isEnableAIAssistant = () => {
  return hasFeatureFlag('is_enable_ai_assistent') && hasRoleOneOf([100, 101, 117, 108, 116, 121]);
};
